const config = {
  /**
   * Local configurations — ZetaChain Athens Testnet
   */
  development: {
    chain: {
      chainId: '0x1B59', // 7001
      chainName: 'ZetaChain Athens Testnet',
      nativeCurrency: { name: 'ZETA', symbol: 'ZETA', decimals: 18 },
      rpcUrls: ['https://zetachain-athens-evm.blockpi.network/v1/rpc/public'],
      blockExplorerUrls: ['https://testnet.zetascan.com'],
    },
    USDT_ADDRESS: '0x1f64f08d2070CDBfa194B6a41744224D6bAe0629',
    VAULT_ADDRESS: '0x4a7752CAaeA8DB2898bfd9295564E519c905C1c4',
  },

  /**
   * Staging configurations — ZetaChain Athens Testnet
   */
  staging: {
    chain: {
      chainId: '0x1B59', // 7001
      chainName: 'ZetaChain Athens Testnet',
      nativeCurrency: { name: 'ZETA', symbol: 'ZETA', decimals: 18 },
      rpcUrls: ['https://zetachain-athens-evm.blockpi.network/v1/rpc/public'],
      blockExplorerUrls: ['https://testnet.zetascan.com'],
    },
    USDT_ADDRESS: '0x1f64f08d2070CDBfa194B6a41744224D6bAe0629',
    VAULT_ADDRESS: '0x4a7752CAaeA8DB2898bfd9295564E519c905C1c4',
  },

  /**
   * !!!WARNING!!!
   * DO NOT CHANGE THE CONFIGURATIONS BELOW. THEY ARE USED BY CI/CD
   *
   * Production configurations — Ethereum Mainnet
   */
  production: {
    chain: {
      chainId: '0x1', // 1
      chainName: 'Ethereum Mainnet',
      nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
      rpcUrls: ['https://eth.llamarpc.com'],
      blockExplorerUrls: ['https://etherscan.io'],
    },
    USDT_ADDRESS: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    VAULT_ADDRESS: '0x0000000000000000000000000000000000000000', // TODO: fill in production vault address
  },
};

export default config;
